// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3ke7Y","headline":"App_headline__3G_pl","componentContainer":"App_componentContainer__27tIi"};